import React, { useEffect } from "react";
import { Form, Input, Select, Button } from "antd";
import { createCategoryForm, updateCategoryForm } from "../../actions/admin";
import { useDispatch } from "react-redux";
import TextArea from "antd/es/input/TextArea";

interface SideDrawerProps {
  categoryData?: any; // Optional organization data
  open?: boolean;
  onClose?: any;
}

const CreateCategory: React.FC<SideDrawerProps> = ({
  categoryData,
  open,
  onClose,
}) => {
  const [form] = Form.useForm();
  const dispatch: any = useDispatch();

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open]);

  const onFinish = async (values: any) => {
    if (categoryData?.id) {
      const updatePayload = { ...values, id: categoryData?.id };
      dispatch(
        updateCategoryForm(updatePayload, (resp: any) => {
          if (resp?.status === 200 || resp?.status === 201) {
            form.resetFields(); // Clear form on successful submission
            onClose();
          }
        })
      );
    } else {
      dispatch(
        createCategoryForm(values, (resp: any) => {
          if (resp?.status === 200 || resp?.status === 201) {
            form.resetFields(); // Clear form on successful submission
            onClose();
          }
        })
      );
    }
  };

  useEffect(() => {
    if (categoryData || (open && categoryData)) {
      form.setFieldsValue({
        name: categoryData?.name, // Use firstName/lastName if name is null
        description: categoryData?.description,
      });
    } else {
      form.resetFields();
    }
  }, [categoryData, open, form]);

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <div className="mb-[20px]">
        <Form.Item
          name="name"
          rules={[
            { required: true, message: "Please enter your categoryName" },
          ]}
        >
          <Input
            placeholder="Category Name"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[15px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#fff] color-[#fff]"
          />
        </Form.Item>
      </div>
      <div className="mb-[10px]">
        <Form.Item
          name="description"
          rules={[{ required: true, message: "Please enter description" }]}
        >
          <TextArea
            showCount
            maxLength={100}
            placeholder="Description"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[15px]  border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff]"
          />
        </Form.Item>
      </div>

      {/* <div className="mb-[20px]">
        <Form.Item
          name="role"
          rules={[{ required: true, message: "Please select a role" }]}
        >
          <Select
            placeholder="Role"
            className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
          >
            <Option value="user">User</Option>
            <Option value="leader">Leader</Option>
          </Select>
        </Form.Item>
      </div> */}

      <div className="mb-[20px]">
        <Form.Item>
          <Button
            htmlType="submit"
            className="p-[25px] text-[12px] w-full text-white rounded-md gradient-button"
          >
            {Object.keys(categoryData)?.length > 0 ? "Update" : "Submit"}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};

export default CreateCategory;
